(function($){

	$( document ).ready(function() {

        // Mobile nav actions
        $('.mobile-nav-btn').on('click', function(e){
            e.preventDefault();

            const isExpanded = $(this).attr('aria-expanded') === 'true';
            $(this).attr('aria-expanded', !isExpanded);

            $(this).toggleClass('is-active');
            $('body, header').toggleClass('nav-active mobile-nav-active');
            $('.mobile-nav').toggleClass('expanded');
        });

        // Mobile nav: first tap opens submenu, second tap follows link
        $('.mobile-nav').on('click', '> ul > li.menu-item-has-children > a', function(e) {
            var $parent = $(this).parent();

            if (!$parent.hasClass('submenu-active')) {
                e.preventDefault();
                $parent.siblings('.submenu-active').removeClass('submenu-active');
                $parent.addClass('submenu-active');
            }
            // If already open, allow default link navigation
        });

        // Close mobile nav/submenus when clicking away from header/mobile nav
        $(document).on('click touchstart', function(e) {
            if (!$(e.target).closest('.header, .mobile-nav').length) {
                $('.mobile-nav > .menu > li').removeClass('submenu-active');

                if ($('.mobile-nav').hasClass('expanded')) {
                    $('.mobile-nav').removeClass('expanded');
                    $('.mobile-nav-btn').removeClass('is-active').attr('aria-expanded', 'false');
                    $('body, header').removeClass('nav-active mobile-nav-active');
                }
            }
        });

        // Header show/hide on scroll for <=1100px
        var $header = $('.header');
        var headerBreakpoint = window.matchMedia('(max-width: 1100px)');
        var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var downScrollDistance = 0;
        var minDelta = 5;
        var hideAfter = 90;

        function resetHeaderState() {
            $header.removeClass('is-hidden');
            downScrollDistance = 0;
            lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        }

        $(window).on('scroll', function() {
            if (!headerBreakpoint.matches) {
                resetHeaderState();
                return;
            }

            if ($('body').hasClass('mobile-nav-active')) {
                $header.removeClass('is-hidden');
                lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
                return;
            }

            var currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
            var delta = currentScrollTop - lastScrollTop;

            if (Math.abs(delta) < minDelta) {
                return;
            }

            if (delta > 0 && currentScrollTop > 30) {
                downScrollDistance += delta;

                if (downScrollDistance >= hideAfter) {
                    $header.addClass('is-hidden');
                }
            } else {
                downScrollDistance = 0;
                $header.removeClass('is-hidden');
            }

            if (currentScrollTop <= 0) {
                downScrollDistance = 0;
                $header.removeClass('is-hidden');
            }

            lastScrollTop = currentScrollTop;
        });

        $(window).on('resize', function() {
            if (!headerBreakpoint.matches) {
                resetHeaderState();
            }
        });

        // Touch device menu handling
        var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        
        if (isTouchDevice) {
            // Handle megamenu items
            $('.desktop-nav > ul > li.megamenu > a').on('click', function(e) {
                var $parent = $(this).parent();
                
                if (!$parent.hasClass('menu-active')) {
                    e.preventDefault();
                    // Close all other open menus
                    $('.desktop-nav > ul > li').removeClass('menu-active');
                    // Open this menu
                    $parent.addClass('menu-active');
                }
                // If already active, allow link to navigate
            });
            
            // Handle sub-menu items
            $('.desktop-nav > ul > li.menu-item-has-children > a').on('click', function(e) {
                var $parent = $(this).parent();
                
                if (!$parent.hasClass('menu-active')) {
                    e.preventDefault();
                    // Close all other open menus
                    $('.desktop-nav > ul > li').removeClass('menu-active');
                    // Open this menu
                    $parent.addClass('menu-active');
                }
                // If already active, allow link to navigate
            });
            
            // Close menus when clicking outside
            $(document).on('click touchstart', function(e) {
                if (!$(e.target).closest('.desktop-nav > ul > li').length) {
                    $('.desktop-nav > ul > li').removeClass('menu-active');
                }
            });
        }

	});

})(jQuery);